import CheckIcon from 'vux/src/components/check-icon/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'


import plupload from 'plupload'
import * as $ from 'jquery'
import * as THREE from 'three'
var STLLoader = require('three-stl-loader')(THREE)
import AsciiEffect from 'three-asciieffect'
import TrackballControls from 'three-trackballcontrols'

var now = new Date();
var date = now.getFullYear() + ((now.getMonth() + 1) < 10 ? "0" : "") + (now.getMonth() + 1) + (now.getDate() < 10 ? "0" : "") + now.getDate();

export default {
name: 'productUpload',
directives: {
TransferDom
},
components: {
CheckIcon,
TransferDom,
Popup
},
data () {
return {
zoomType: 'yes',
test: true,
showClassify: false,
highModulus: {
name: '上传高模文件',
filePath: '',
fileSize: 0
},
productDatas: {
title: '',	// 名称
categoryId: '',	// 分类ID
spuName: '',
detail: '',// 描述
filename: '',	// 3D文件名
len: '',	// 长
width: '',	// 宽
height: '',	// 高
bulk: '',
ossKey: '',	// oss key 低模
ossKeyHigh: '',	// 高模
ossKeyStl: '',
imagePath: '',	// 主图路径
listRealImgs: '',	// 实物图
listImgs: '',	// 颜色图
listSkus: '',	// sku
listTags: '',	//标签
unzoom: '',	// 是否可缩放
},
productDatasLenWidthHeight: '',
materialsList: [],
colorList: [],
parameterItemNum: 1,
}
},
methods: {
whetherZoom (val) {
this.zoomType = val
},



initPlUploader () {
let that = this
var uploader = new plupload.Uploader({
runtimes: "html5,flash,silverlight,html4",
browse_button: "uploadHighModulus",
flash_swf_url: 'lib/plupload-2.1.2/js/Moxie.swf',
silverlight_xap_url: 'lib/plupload-2.1.2/js/Moxie.xap',
chunk_size: '1mb',
headers: {
token: that.$token
},

unique_names: true,


url: that.$baseURL + '/product/uploadfile',
multi_selection: false,

filters: {




mime_types: [],

prevent_duplicates: false 
},

init: {
PostInit: function() {
document.getElementById('serverfile').innerHTML = '';





},

FilesAdded: function(up, files) {
if(files[0].name.split('.')[1] != 'stl' && files[0].name.split('.')[1] != 'STL') {
uploader.removeFile(files)
up.files.splice(0,1)
that.$vux.toast.show({
type: 'warn',
text: '只支持stl文件'
})
return false;
}
document.getElementById('serverfile').innerHTML = '';
up.start();
plupload.each(files, function (file) {
document.getElementById('serverfile').innerHTML += '<div class="' + file.size + '" id="' + file.id + '">高模 : ' + file.name + ' (' + plupload.formatSize(file.size) + ')<b></b>' +
'<div class="progress"><div class="progress-bar" style="width: 0%"></div></div>' +
'</div>';
console.log(file);
that.highModulus.fileSize = file.size
});
that.$vux.loading.show({
text: ''
})
},
removeFile: function(file) {
console.log(file)
},

UploadProgress: function(up, file) {
var d = document.getElementById(file.id);
d.getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>";
var prog = d.getElementsByTagName('div')[0];
var progBar = prog.getElementsByTagName('div')[0]
progBar.style.width = 2 * file.percent + 'px';
progBar.setAttribute('aria-valuenow', file.percent);
},

FileUploaded: function(up, file, info) {
if (info.status == 200) {
that.highModulus.name = file.name
that.productDatas.title = file.name
that.$vux.loading.hide()
setTimeout(function () {
$('#serverfile').hide();
}, 2000)
document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = '上传成功';
var filePath = that.$baseURL + 'upload/' + date + '/' + file.id + '.stl';
that.highModulus.filePath = filePath



console.log(file)
console.log(info)

that.$request.post('/product/change',{
filePath: date + '/' + file.target_name,
}).then(data => {
if(data.code == 0){
that.fileScanner(data.obj.ossKeyStl)

}else{
that.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}
},

Error: function(up, err) {
if (err.code == -600) {
document
.getElementById("console")
.appendChild(
document.createTextNode(
"\n选择的文件太大了,可以根据应用情况，在upload.js 设置一下上传的最大大小"
)
);
} else if (err.code == -601) {
document
.getElementById("console")
.appendChild(
document.createTextNode(
"\n选择的文件后缀不对,可以根据应用情况，在upload.js进行设置可允许的上传文件类型"
)
);
} else if (err.code == -602) {
document
.getElementById("console")
.appendChild(
document.createTextNode("\n这个文件已经上传过一遍了")
);
} else {
document
.getElementById("console")
.appendChild(
document.createTextNode("\nError xml:" + err.response)
);
}
}
}
});
uploader.init();
},

fileScanner(filePath) {
var WIDTH, HEIGHT;
var renderer;
var that = this;

function initThree() {

WIDTH = 375;
HEIGHT = 375;
/* 渲染器 */
renderer = new THREE.WebGLRenderer({
antialias: true, //是否开启反锯齿
precision: "highp", //着色精度选择
alpha: true, //是否可以设置背景色透明
premultipliedAlpha: false,
stencil: false,
preserveDrawingBuffer: true, //是否保存绘图缓冲
maxLights: 8 
});
renderer.setSize(WIDTH, HEIGHT);

renderer.setClearColor(new THREE.Color('#f4f4f4'));
renderer.gammaInput = true;
renderer.gammaOutput = true;



}

/* 设置摄像头 */
var camera;

function initCamera() {
var VIEW_ANGLE = 45,
ASPECT = WIDTH / HEIGHT,
NEAR = 1,
FAR = 10000;

camera = new THREE.PerspectiveCamera(VIEW_ANGLE, ASPECT, NEAR, FAR);

camera.position.set(50, 0, 0);
camera.up.set(0, 0, 1)

camera.lookAt(300, 0, 0);






}

/* 场景 */
var scene;

function initScene() {
scene = new THREE.Scene();


}

/* 灯光 */
var light, light2, light3;

function initLight() {

light = new THREE.DirectionalLight(0xFFFFFF);
light.position.set(0, 99, 0).normalize();
scene.add(light);



light2 = new THREE.AmbientLight(0x999999);
scene.add(light2);

light3 = new THREE.PointLight(0xFFFFFF);
light3.position.set(250, -200, 100);
scene.add(light3);







}

/* 显示对象 */
var cube;

var initObject = () => {



var stlloader = new STLLoader();





var geometry = new THREE.Geometry(260, 35, 185, 1, 1, 1)




stlloader.load(filePath, (geometry) => {
console.log(geometry)
















var material1 = new THREE.MeshLambertMaterial({
ambient: '#4a90ea',
color: '#4a90ea',
specular: '#fff',
shininess: 200
});


var mat = new THREE.MeshLambertMaterial({
color: 0xFFD700
});
var mesh = new THREE.Mesh(geometry, material1)
console.log(geometry);


geometry.center();

mesh.rotation.set(0, 0, 1.55);

mesh.position.set(0, 0, 0);

var originalx = geometry.boundingBox.max.x;
var originaly = geometry.boundingBox.max.y;
var originalz = geometry.boundingBox.max.z;
console.log(originalx, originaly, originalz);


var originalmax = Math.max(originalx, originaly, originalz);






if (geometry instanceof THREE.BufferGeometry) {
geometry = new THREE.Geometry().fromBufferGeometry(geometry);


}



var volume = 0;
var volumes = 0.0;
var Area = 0.0;

for (let f = 0, fl = geometry.faces.length; f < fl; f++) {
var face = geometry.faces[f];
var vA = geometry.vertices[face.a];
var vB = geometry.vertices[face.b];
var vC = geometry.vertices[face.c];

var x1 = vA.x,
x2 = vB.x,
x3 = vC.x;
var y1 = vA.y,
y2 = vB.y,
y3 = vC.y;
var z1 = vA.z,
z2 = vB.z,
z3 = vC.z;

var V = (-x3 * y2 * z1 + x2 * y3 * z1 + x3 * y1 * z2 - x1 * y3 * z2 - x2 * y1 * z3 + x1 * y2 * z3) / 6;
volume += V;

}


function volumeOfT(p1, p2, p3) {
var v321 = p3.x * p2.y * p1.z;
var v231 = p2.x * p3.y * p1.z;
var v312 = p3.x * p1.y * p2.z;
var v132 = p1.x * p3.y * p2.z;
var v213 = p2.x * p1.y * p3.z;
var v123 = p1.x * p2.y * p3.z;
return (-v321 + v231 + v312 - v132 - v213 + v123) / 6.0;
}

function AreaOfTriangle(p1, p2, p3) {
var ax = p2.x - p1.x;
var ay = p2.y - p1.y;
var az = p2.z - p1.z;
var bx = p3.x - p1.x;
var by = p3.y - p1.y;
var bz = p3.z - p1.z;
var cx = ay * bz - az * by;
var cy = az * bx - ax * bz;
var cz = ax * by - ay * bx;
return (0.5 * Math.sqrt(cx * cx + cy * cy + cz * cz));
}

for (var i = 0; i < geometry.faces.length; i++) {
var Pi = geometry.faces[i].a;
var Qi = geometry.faces[i].b;
var Ri = geometry.faces[i].c;
var P = new THREE.Vector3(geometry.vertices[Pi].x, geometry.vertices[Pi].y, geometry.vertices[Pi].z);
var Q = new THREE.Vector3(geometry.vertices[Qi].x, geometry.vertices[Qi].y, geometry.vertices[Qi].z);
var R = new THREE.Vector3(geometry.vertices[Ri].x, geometry.vertices[Ri].y, geometry.vertices[Ri].z);
volumes += volumeOfT(P, Q, R); 

Area += AreaOfTriangle(R, Q, P);
}

console.log(geometry);
console.log('体积1:' + Math.abs(volumes));
console.log('体积2:' + Math.abs(volume));
console.log('表面积：' + Area);
console.log('长' , geometry.boundingBox.max.x + Math.abs(geometry.boundingBox.min.x));
console.log('宽' , geometry.boundingBox.max.y + Math.abs(geometry.boundingBox.min.y));
console.log('高' , geometry.boundingBox.max.z + Math.abs(geometry.boundingBox.min.z));

let length = Math.ceil(geometry.boundingBox.max.x + Math.abs(geometry.boundingBox.min.x))
let width = Math.ceil(geometry.boundingBox.max.y + Math.abs(geometry.boundingBox.min.y))
let height = Math.ceil(geometry.boundingBox.max.z + Math.abs(geometry.boundingBox.min.z))



var arg = 15 / originalmax;


mesh.scale.set(arg, arg, arg);

scene.add(mesh)

var canvasUrl = renderer.domElement.toDataURL("image/png");





that.productDatas.bulk = Math.abs(Math.floor(Number(volumes) * 100) / 100)
that.productDatas.len = length
that.productDatas.width = width
that.productDatas.height = height
that.productDatasLenWidthHeight = length+' x '+width+' x '+height

that.$request.post('/product/listMaterialsAndPrices',{
length,
width,
height,
volume: Math.abs(volumes),
surface: Area,
}).then(backData => {
if(backData.code == 0){
console.log(backData);
backData.obj.list.forEach((item, index) => {
item.checkStatus = false
item.designerPrice = (item.price*1000 * 3*1000 )/1000000
})
that.materialsList = [...backData.obj.list]
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},

function (xhr) {



if ((xhr.loaded / xhr.total * 100) + '% loaded' === '100% loaded') {

}
},








)


}


var effect;
var controls;

var _this = this;
function initControl() {
effect = new AsciiEffect(renderer);
effect.setSize(WIDTH, HEIGHT);
controls = new TrackballControls(camera, renderer.domElement);

controls.minDistance = 30;

controls.maxDistance = 150;

_this.controls = controls
}


function animate() {
requestAnimationFrame(animate);
controls.update();
effect.render(scene, camera);
}


function threeStart() {

initThree();
initScene();

initCamera();
initLight();

initObject();
initControl();
animate();
}

threeStart();
},
getColorList () {	//获取颜色
this.$request.post('/product/listColors',{

}).then(backData => {
if(backData.code == 0){
console.log(backData);
this.colorList = [...backData.obj]
}else{
this.$vux.toast.show({
type: 'cancel',
text: backData.msg
})
}
}).catch(e => {
console.log(e)
})
},
addColor () {	//添加颜色
if(this.materialsList.length != 0){
this.parameterItemNum += 1
}
},
},
computed: {

},
mounted() {
this.initPlUploader()
this.getColorList()
},
created () {

}
}



// WEBPACK FOOTER //
// ./src/views/myStore/productUpload/script.js